import { render, staticRenderFns } from "./ComboOfferSaleBase.vue?vue&type=template&id=515d67ec&scoped=true"
import script from "./ComboOfferSaleBase.vue?vue&type=script&lang=js"
export * from "./ComboOfferSaleBase.vue?vue&type=script&lang=js"
import style0 from "./ComboOfferSaleBase.vue?vue&type=style&index=0&id=515d67ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d67ec",
  null
  
)

export default component.exports